import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateEquipmentApi } from "./equipmentAPI";

const initialState = []

export const updateEquipment = createAsyncThunk(
    'ui/fetchEquipmentModals',
    async (obj, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await updateEquipmentApi(obj);
      return response.data;
    }
);

const equipmentUpdateSlice = createSlice({
    name: 'equipmentUpdate',
    initialState,
    reducers: {
      setInverterData: (state, action) => {
     
        //state.inverter = action.payload?.inverter;
      }
    },
    extraReducers: (builder) => {
        builder
          .addCase(updateEquipment.pending, (state) => {
            return {
              ...state,
              status: "loading",
              updateLoaded: false,
              updateApiFailed: false,
              updateResponse: initialState
            }
          })
          .addCase(updateEquipment.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              updateResponse: action.payload,
              updateApiFailed: false,
              updateLoaded: true
            }
          })
          .addCase(updateEquipment.rejected, (state) => {
            return {
              ...state,
              updateLoaded: true,
              status: "idle",
              updateApiFailed: true,
            }
          })
        },
});

export const getEquipmentUpdateResponse = (state) => state.equipmentUpdate?.updateResponse;

export default equipmentUpdateSlice.reducer;
